import { render, staticRenderFns } from "./ChangeLabels.vue?vue&type=template&id=0b3ed3a7"
import script from "./ChangeLabels.vue?vue&type=script&lang=js"
export * from "./ChangeLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports